
const digest = '4be2640b6117455edda00f13716f16dc772d109aff427b92fa89a8ccf0174c60';
const classes = {"wrapper":"_wrapper_1s3dn_1","text":"_text_1s3dn_10"};
const css = `._wrapper_1s3dn_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 6px 0;
  font-family: Rubik, "sans-serif";
}

._text_1s3dn_10 {
  font-size: 14px;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  